const ENV_NAME = 'prod';

const LAMBDA_API_URL_01 = 'https://func-prod-medrecord-westus2-001.azurewebsites.net/api/';
const LAMBDA_API_URL_02 = 'https://func-prod-medrecord-westus2-002.azurewebsites.net/api/';
const LAMBDA_API_URL_03 = 'https://func-prod-medrecord-westus2-003.azurewebsites.net/api/';
const LAMBDA_API_URL_04 = 'https://func-prod-medrecord-westus2-004.azurewebsites.net/api/';
const LAMBDA_API_URL_05 = 'https://func-prod-medrecord-westus2-005.azurewebsites.net/api/';
const LAMBDA_API_URL_06 = 'https://func-prod-medrecord-westus2-006.azurewebsites.net/api/';
const PHP_API_URL = 'https://api.medrecordexchange.com/prod/';
const PHP_AHS_API_URL = 'https://api.medrecordexchange.com/prod/ahs_php/';
const TRANSCRIBE_API_URL = "https://app-prod-ashchatgpt.azurewebsites.net/";
const VIDEO_API_URL = "https://app-videosummerize-eastus.azurewebsites.net/";


export const environment = {
  production: false,
  environmentName: ENV_NAME,
  lambdaApiUrl_01: LAMBDA_API_URL_01,
  lambdaApiUrl_02: LAMBDA_API_URL_02,
  lambdaApiUrl_03: LAMBDA_API_URL_03,
  lambdaApiUrl_04: LAMBDA_API_URL_04,
  lambdaApiUrl_05: LAMBDA_API_URL_05,
  lambdaApiUrl_06: LAMBDA_API_URL_06,
  phpApiUrl: PHP_API_URL,
  phpAhsApiUrl: PHP_AHS_API_URL,
  transcribeApiUrl: TRANSCRIBE_API_URL,
  videoApiUrl: VIDEO_API_URL
};
console.log("environment...",environment)